import { dateFormat, useDateRange } from "@/pages/dashboard/hooks/useDateRange";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";

interface GetDashboardOrderCounts {
  po: number;
  so: number;
  purchased_quantity: number;
  sold_quantity: number;
  total: number;
}

export function useDashboardOrderCounts({ productId }: { productId?: number }) {
  const { startDate, endDate } = useDateRange();

  const extraParams = productId ? { product_id: productId } : {};

  const query = useQuery({
    queryKey: ["dashboard", "po_so", startDate, endDate, productId],
    enabled: !!startDate && !!endDate,
    queryFn: () =>
      axios
        .get<GetDashboardOrderCounts>("/dashboard/order_counts", {
          params: {
            end_date: endDate?.format(dateFormat),
            start_date: startDate?.format(dateFormat),
            ...extraParams,
          },
        })
        .then((result) => result.data),
  });

  return query;
}
